import React from "react";
import WishlistCard from "../components/Wishlist-Card/WishlistCard";
import ProductCard from "../components/Card/ProductCard";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getWishlistProducts } from "../appState/slices/wishlist/wishlistSlice";
import { setNavbarDark } from "../../src/appState/slices/auth/authSlice";
import Empty from "../components/EmptyComponent/Empty";

const Wishlist = () => {
    const wishlistproducts = useSelector(state => state.wishlist.products);
    const flag = useSelector(state => state.auth.flag);

    const dispatch = useDispatch();
    useEffect(() => {
        // dispatch(setNavbarDark(true));
        dispatch(getWishlistProducts());
    }, [flag])
    return (
        <div className="cartcontainer">
            <div className="container-fluid">
                <div className="row cartleftmargin">
                    {
                        wishlistproducts.length ? wishlistproducts?.map((product) => {
                            return (
                                <div className="col-lg-3 col-md-3 col-sm-6 ps-0 pe-1 pb-1 ">
                                    <ProductCard cardcartbtn="Add to bag" product={product} />
                                </div>
                            )
                        }) :
                            <Empty icon="SmileySad" title="Your Wishlist is Empty" subtitle="Save your wishlist and share it with anyone you want." />
                    }
                </div>
            </div>
        </div>
    )
}

export default Wishlist;